import React from 'react';
import './Input.css';

import PlacesAutocomplete from 'react-places-autocomplete'

import { API_BASE } from '../config';

import Notification from './Notification';

export default React.createClass({
  
  componentDidMount: function() {
      
  },

  componentWillReceiveProps: function(newProps) {
    this.setState({
      value:newProps.value || ""
    });
  },

  getInitialState: function() {
    return {
      value: this.props.value || "",
      autofill:false,
      changed:false,
      notificationText:"",
      saved:true,
      saving:false
    };
  },

  handleFocus: function(event) {
    if (this.props.onFocus) {
      this.props.onFocus(this.props.name,this.state.value);
    }
  },

  handleBlur: function(event) {
    if (this.state.changed && !this.props.noSave) { // only fire if value changed
      this._save();
    }
    if (this.props.onBlur) {
      this.props.onBlur(this.props.name,this.state.value);
    }
  },

  handleSelect: function(address) {
    if (this.state.changed && !this.props.noSave) { // only fire if value changed
      this._save();
    }
    if (this.props.onBlur) {
      this.props.onChange(this.props.name,address);
      this.props.onBlur(this.props.name,address);
    }
  },

  handleChange: function(value) {
    
    var changed = true;

    this.setState({
      value: value,
      changed:changed,
      saved:false
    },function() {
      if (this.props.onChange) {
        this.props.onChange(this.props.name,this.state.value);
      }
    });
  },
  
  reset: function() {
    this.setState({
      value: this.props.value
    },function() {
      if (this.props.onChange) {
        this.props.onChange(this.props.name,this.state.value);
      }
    });
  },
  
  render: function() {

      const inputProps = {
        value: !this.state.changed ? this.props.value : this.state.value,
        onChange:this.handleChange,
        onBlur:this.handleBlur,
        onSelect:this.handleSelect
      }

      const renderFunc = ({ getInputProps, getSuggestionItemProps, suggestions }) => (
        <div className="autocomplete-root">
          <input {...getInputProps()} onFocus={this.handleFocus} />
          <div className="autocomplete-dropdown-container">
            {suggestions.map(suggestion => (
              <div {...getSuggestionItemProps(suggestion)}>
                <span>{suggestion.description}</span>
              </div>  
            ))}
          </div>
        </div>
      );

      var className = { input:"" };
      if (this.props.className) { className["input"] += " "+this.props.className; }
      if (!this.state.value) { className["input"] += " empty"; }

      var styles = {}
      styles["input"] = this.props.style;

      return (
      	  <div className="fieldSet">
            <Notification text={this.state.notificationText} />
      	    {this.props.label ? <div className="clearflex justify-flex-start">
              <label data-for={this.props.name}>{this.props.label}</label>
            </div> : "" }
            <PlacesAutocomplete {...inputProps} classNames={className} styles={styles} onEnterKeyDown={this._keyboardListen_enter}>{renderFunc}</PlacesAutocomplete>
            {!this.state.autofill ||
              this.state.autofill.map((item, index) => (
                <span key="index">{item.key}</span>
              ))
            }
          </div>
      );
    
  },

  value: function() {
    return this.state.value;
  },

  _keyboardListen_enter(e) {
      if (this.props.onKeyDown) {
        this.props.onKeyDown(e);
      }

      if (e.keyCode === 13) {
          this.handleBlur(e);
          e.target.blur();
      }
  },

  _save: function() {

      var _this = this;

      // get values for update
      var endpoint = this.props.endpoint;
      var id = this.props.id;
      var field = this.props.name;
      var value = this.state.value;

      //console.log(_this.state.token);

      var request = new Request(`${API_BASE}`+endpoint+"/"+id+"?"+field+"="+value, {
        method: 'PUT', 
        mode: 'cors', 
        headers: new Headers({
          'Authorization': localStorage.getItem('token')
        })
      });

      _this.setState({ notificationText:"Saving..." });
      fetch(request).then(function(response) {
        //console.log(response);

        if (response.status === 200) {
          _this.setState({
            notificationText:"Saved 👍"
          });
        }

        //return response.json();
      })/*.then(function(json) { // don't need json... blank on successful response
        console.log(json);

        // clear form and success message
        _this.setState({
          notificationText:"Dancer updated."
        });
        

      })*/.catch(function(ex) {
        console.log('parsing failed', ex);
      });

  }

})


// WEBPACK FOOTER //
// ./src/components/Input-Address.js